import * as actions from '../actions/actionTypes';
import initialState from './initialState';

/**
 * This reducer handles the LOAD_TRS_DATA_BY_CLIENT_PERIOD_SUCCESS action and sets an array of TRS Data in the store
 * @param {Array} [state] The TRS Data currently in the store, or the initial state of TRS Data
 * @param {Object} action The action to be handled
 * @returns {Array} The TRS Data
 */
export default function trsClientReportPeriodData(
  state = initialState.trsClientReportPeriodData,
  action
) {
  switch (action.type) {
    case actions.LOAD_TRS_DATA_BY_CLIENT_PERIOD_SUCCESS:
      return action.trsClientReportPeriodData;
    case actions.LOAD_TRS_DATA_BY_CLIENT_PERIOD_FAILURE:
      return initialState.trsClientReportPeriodData;
    default:
      return state;
  }
}
